/**
 * How long the composer has been listening, as it says it: "0:07", "1:43".
 *
 * The minutes are not padded. A dictation is a sentence or two, so "00:07"
 * would wear the face of a stopwatch on something that is over before anyone
 * reads it twice.
 */
export function dictationClock(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));

  return `${Math.floor(safe / 60)}:${String(safe % 60).padStart(2, '0')}`;
}
